import React, { Component } from 'react';
import '../App.css';
import { render } from '@testing-library/react';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as firebase from 'firebase';
import firebaseConfig from "../config"
import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  }


firebase.analytics();

class Haikyuu extends Component{
state={
  boucle: 1,
  etape: 1,
  result: null

}

connexion = e =>{

  var provider = new firebase.auth.TwitterAuthProvider();
  firebase.auth().languageCode = 'fr';
// To apply the default browser preference instead of explicitly setting it.
// firebase.auth().useDeviceLanguage();
provider.setCustomParameters({
  'lang': 'fr'
});


firebase.auth().signInWithPopup(provider).then((result) => {
  // This gives you a the Twitter OAuth 1.0 Access Token and Secret.
  // You can use these server side with your app's credentials to access the Twitter API.
  var token = result.credential.accessToken;
  var secret = result.credential.secret;
  // The signed-in user info.
  var user = result.user;
  






  this.setState({
    etape: 2
  })


}).catch(function(error) {
  // Handle Errors here.
  var errorCode = error.code;
  var errorMessage = error.message;
  // The email of the user's account used.
  var email = error.email;
  // The firebase.auth.AuthCredential type that was used.
  var credential = error.credential;
  // ...
});


}

deco = e =>{
  firebase.auth().signOut().then(() => {
    
    document.location.reload(true)

  }).catch(function(error) {
    // An error happened.
  });
}

componentDidMount(){




  firebase.auth().onAuthStateChanged((user) => {
    if (user) {

      var rudy = Math.floor((Math.random() * Math.floor(21))+1)
      this.setState({
        etape: 2,
        result: rudy
      })

    } else {
      // No user is signed in.
    }
  });




  setInterval(() => {
      
    var rudy = Math.floor((Math.random() * Math.floor(23))+1)

    this.setState({
      boucle: rudy
    })

  }, 800);



}

resultatco = e =>{
    this.setState({
        etape: 3
    })
}




  render(){


    var NomDuPerso


    if(this.state.result == 1){NomDuPerso = "Akaashi"}
    if(this.state.result == 2){NomDuPerso = "Asahi"}
    if(this.state.result == 3){NomDuPerso = "Atsumu"}
    if(this.state.result == 4){NomDuPerso = "Daichi"}
    if(this.state.result == 5){NomDuPerso = "Eita"}
    if(this.state.result == 6){NomDuPerso = "Ennoshita"}
    if(this.state.result == 7){NomDuPerso = "Goshiki"}
    if(this.state.result == 8){NomDuPerso = "Hinata"}
    if(this.state.result == 9){NomDuPerso = "Hoshiumi"}
    if(this.state.result == 10){NomDuPerso = "Kageyama"}
    if(this.state.result == 11){NomDuPerso = "Kenma"}
    if(this.state.result == 12){NomDuPerso = "Kuroo"}
    if(this.state.result == 13){NomDuPerso = "Lev"}
    if(this.state.result == 14){NomDuPerso = "Nishinoya"}
    if(this.state.result == 15){NomDuPerso = "Oikawa"}
    if(this.state.result == 16){NomDuPerso = "Osamu"}
    if(this.state.result == 17){NomDuPerso = "Shimizu"}
    if(this.state.result == 18){NomDuPerso = "Sugawara"}
    if(this.state.result == 19){NomDuPerso = "Tanaka"}
    if(this.state.result == 20){NomDuPerso = "Ukai"}
    if(this.state.result == 21){NomDuPerso = "Tsunade"}
    if(this.state.result == 22){NomDuPerso = "Ushijima"}
    if(this.state.result == 23){NomDuPerso = "Yamaguchi"}



  return (
    <div><div className="container">
    <a  href="/" >
    <img className="logosite" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/logo%2Fblack.png?alt=media&token=dd05b239-fb5c-45fe-b7c5-cd2e4e0fe953"></img>
    </a>
      <h3 className="titleprincipal">Quel personnage de Haikyuu es-tu ?</h3>

{this.state.etape == 1 && <div>

      {/* Boucle qui montre les persos qui peuvent être choisi */}
      <div className="boucleimg"> 
        {this.state.boucle == 1 && <img className="photoboucleimg" id="Akaashi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FAkaashi.png?alt=media&token=870a2a99-b5b2-425e-8936-dccd367bda6e"></img>}
        {this.state.boucle == 2 && <img className="photoboucleimg" id="Asahi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FAsahi.png?alt=media&token=3edd4a55-1f4e-43eb-b844-e6d5bb3f503b"></img>}
        {this.state.boucle == 3 && <img className="photoboucleimg" id="Atsumu" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FAtsumu.png?alt=media&token=e46a5f73-4c06-4134-a17e-7065c4a6c2ec"></img>}
        {this.state.boucle == 4 && <img className="photoboucleimg" id="Daichi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FDaichi.png?alt=media&token=cad64ccc-ded1-401f-8246-95a7090136f2"></img>}
        {this.state.boucle == 5 && <img className="photoboucleimg" id="Eita" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FEita.png?alt=media&token=3ba17dff-caf4-478f-9d3a-3bdd363077be"></img>}
        {this.state.boucle == 6 && <img className="photoboucleimg" id="Ennoshita" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FEnnoshita.png?alt=media&token=2b2804f5-b2b5-40d9-b5ec-02e5e8672540"></img>}
        {this.state.boucle == 7 && <img className="photoboucleimg" id="Goshiki" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FGoshiki.png?alt=media&token=22448e3f-bc30-430b-873b-8a2547cf3d45"></img>}
        {this.state.boucle == 8 && <img className="photoboucleimg" id="Hinata" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FHinata.png?alt=media&token=c4c4845e-791e-47ec-ae1c-5a81bc6e2916"></img>}
        {this.state.boucle == 9 && <img className="photoboucleimg" id="Hoshiumi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FHoshiumi.png?alt=media&token=ab980fe8-a6cb-44f6-a661-947bffe85b79"></img>}
        {this.state.boucle == 10 && <img className="photoboucleimg" id="Kageyama" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FKageyama.png?alt=media&token=d563bd0a-9974-4031-94b3-b9e7be7b7f91"></img>}
        {this.state.boucle == 11 && <img className="photoboucleimg" id="Kenma" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FKenma.png?alt=media&token=2a1fd5b2-5266-4c85-8be3-0ef6ddb58cfa"></img>}
        {this.state.boucle == 12 && <img className="photoboucleimg" id="Kuroo" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FKuroo.png?alt=media&token=48a80071-a0ea-4dd7-8b70-c7ec23f766ba"></img>}
        {this.state.boucle == 13 && <img className="photoboucleimg" id="Lev" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FLev.png?alt=media&token=9fc1e218-bbc4-40e4-b029-d17ee57d7b9e"></img>}
        {this.state.boucle == 14 && <img className="photoboucleimg" id="Nishinoya" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FNishinoya.png?alt=media&token=f2c9fb4e-4d46-4172-a4b6-583f7dcc6421"></img>}
        {this.state.boucle == 15 && <img className="photoboucleimg" id="Oikawa" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FOikawa.png?alt=media&token=ac6496a5-4928-4939-9fac-a979575ef9ec"></img>}
        {this.state.boucle == 16 && <img className="photoboucleimg" id="Osamu" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FOsamu.png?alt=media&token=babb064c-982c-43fb-b3ab-a756460ad5ea"></img>}
        {this.state.boucle == 17 && <img className="photoboucleimg" id="Shimizu" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FShimizu.png?alt=media&token=43961c8e-0224-4c27-bb7f-f5ce4ec2e8af"></img>}
        {this.state.boucle == 18 && <img className="photoboucleimg" id="Sugawara" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FSugawara.png?alt=media&token=e92e6d83-fab7-4b6c-a5bd-641886cd9bcb"></img>}
        {this.state.boucle == 19 && <img className="photoboucleimg" id="Tanaka" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FTanaka.png?alt=media&token=170f5197-dafd-4e1e-8948-c584545fe643"></img>}
        {this.state.boucle == 20 && <img className="photoboucleimg" id="Tsukkishima" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FTsukkishima.png?alt=media&token=972ed0ca-c2c5-404c-80b4-71d201e21ee4"></img>}
        {this.state.boucle == 21 && <img className="photoboucleimg" id="Ukai" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FUkai.png?alt=media&token=470376ae-1f5c-4d1b-82f6-c055f5852eca"></img>}
        {this.state.boucle == 22 && <img className="photoboucleimg" id="Ushijima" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FUshijima.png?alt=media&token=88576faa-3df0-46e1-b174-181f649c01ea"></img>}
        {this.state.boucle == 23 && <img className="photoboucleimg" id="Yamaguchi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FYamaguchi.png?alt=media&token=9748cfd1-d870-4168-be41-9ea5b9b2c027"></img>}
        {/* {this.state.boucle == 7 && <img id="Gaara" src="#"></img>} */}
      </div>


      <button className="button_connexion" onClick={this.connexion}><img className="twitterlogobutton" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/twitter_PNG15.png?alt=media&token=5e474f5f-f84f-45a6-aa12-d4ad05f6d021"></img>Connexion avec Twitter</button>
</div>}




{this.state.etape == 2 && <div>

    <button className="button_connexion" onClick={this.resultatco}>Découvrir le résultat !</button>

    <p className="manquement">Tu es connecté via Twitter, <a href='#' onClick={this.deco}>Deconnexion</a></p>


                            </div>}



    {this.state.etape == 3 && <div>

  <div className="boucleimg">
        {this.state.result == 1 && <img className="photoboucleimg" id="Akaashi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FAkaashi.png?alt=media&token=870a2a99-b5b2-425e-8936-dccd367bda6e"></img>}
        {this.state.result == 2 && <img className="photoboucleimg" id="Asahi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FAsahi.png?alt=media&token=3edd4a55-1f4e-43eb-b844-e6d5bb3f503b"></img>}
        {this.state.result == 3 && <img className="photoboucleimg" id="Atsumu" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FAtsumu.png?alt=media&token=e46a5f73-4c06-4134-a17e-7065c4a6c2ec"></img>}
        {this.state.result == 4 && <img className="photoboucleimg" id="Daichi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FDaichi.png?alt=media&token=cad64ccc-ded1-401f-8246-95a7090136f2"></img>}
        {this.state.result == 5 && <img className="photoboucleimg" id="Eita" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FEita.png?alt=media&token=3ba17dff-caf4-478f-9d3a-3bdd363077be"></img>}
        {this.state.result == 6 && <img className="photoboucleimg" id="Ennoshita" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FEnnoshita.png?alt=media&token=2b2804f5-b2b5-40d9-b5ec-02e5e8672540"></img>}
        {this.state.result == 7 && <img className="photoboucleimg" id="Goshiki" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FGoshiki.png?alt=media&token=22448e3f-bc30-430b-873b-8a2547cf3d45"></img>}
        {this.state.result == 8 && <img className="photoboucleimg" id="Hinata" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FHinata.png?alt=media&token=c4c4845e-791e-47ec-ae1c-5a81bc6e2916"></img>}
        {this.state.result == 9 && <img className="photoboucleimg" id="Hoshiumi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FHoshiumi.png?alt=media&token=ab980fe8-a6cb-44f6-a661-947bffe85b79"></img>}
        {this.state.result == 10 && <img className="photoboucleimg" id="Kageyama" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FKageyama.png?alt=media&token=d563bd0a-9974-4031-94b3-b9e7be7b7f91"></img>}
        {this.state.result == 11 && <img className="photoboucleimg" id="Kenma" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FKenma.png?alt=media&token=2a1fd5b2-5266-4c85-8be3-0ef6ddb58cfa"></img>}
        {this.state.result == 12 && <img className="photoboucleimg" id="Kuroo" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FKuroo.png?alt=media&token=48a80071-a0ea-4dd7-8b70-c7ec23f766ba"></img>}
        {this.state.result == 13 && <img className="photoboucleimg" id="Lev" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FLev.png?alt=media&token=9fc1e218-bbc4-40e4-b029-d17ee57d7b9e"></img>}
        {this.state.result == 14 && <img className="photoboucleimg" id="Nishinoya" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FNishinoya.png?alt=media&token=f2c9fb4e-4d46-4172-a4b6-583f7dcc6421"></img>}
        {this.state.result == 15 && <img className="photoboucleimg" id="Oikawa" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FOikawa.png?alt=media&token=ac6496a5-4928-4939-9fac-a979575ef9ec"></img>}
        {this.state.result == 16 && <img className="photoboucleimg" id="Osamu" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FOsamu.png?alt=media&token=babb064c-982c-43fb-b3ab-a756460ad5ea"></img>}
        {this.state.result == 17 && <img className="photoboucleimg" id="Shimizu" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FShimizu.png?alt=media&token=43961c8e-0224-4c27-bb7f-f5ce4ec2e8af"></img>}
        {this.state.result == 18 && <img className="photoboucleimg" id="Sugawara" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FSugawara.png?alt=media&token=e92e6d83-fab7-4b6c-a5bd-641886cd9bcb"></img>}
        {this.state.result == 19 && <img className="photoboucleimg" id="Tanaka" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FTanaka.png?alt=media&token=170f5197-dafd-4e1e-8948-c584545fe643"></img>}
        {this.state.result == 20 && <img className="photoboucleimg" id="Tsukkishima" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FTsukkishima.png?alt=media&token=972ed0ca-c2c5-404c-80b4-71d201e21ee4"></img>}
        {this.state.result == 21 && <img className="photoboucleimg" id="Ukai" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FUkai.png?alt=media&token=470376ae-1f5c-4d1b-82f6-c055f5852eca"></img>}
        {this.state.result == 22 && <img className="photoboucleimg" id="Ushijima" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FUshijima.png?alt=media&token=88576faa-3df0-46e1-b174-181f649c01ea"></img>}
        {this.state.result == 23 && <img className="photoboucleimg" id="Yamaguchi" src="https://firebasestorage.googleapis.com/v0/b/quelpersonnagees-tu.appspot.com/o/h%2FYamaguchi.png?alt=media&token=9748cfd1-d870-4168-be41-9ea5b9b2c027"></img>}
        </div>       

    <h5 className="text_result">Tu es {NomDuPerso} !</h5>
    <p className="titleshare">Prends une capture et partage-le dès maintenant sur Twitter !</p>

<div className="centerContent">
<div className="selfCenter">
<TwitterShareButton url="https://bit.ly/3e2sRyr" 

options={{
    text: `Je suis ${NomDuPerso} dans Haikyuu 🏐! Tu peux essayer ici:`,
    size: 'large',
    via: 'dyrudyru',
  }} placeholder={<div />} />
</div>
</div>


    <p className="manquement">Il manque un personnage que vous aimez? <a href="https://twitter.com/messages/compose?recipient_id=1072970252298915842">Dites-le moi !</a></p>

<a href="#" className="deco" onClick={this.deco}>Deconnexion</a>


    </div>}
    </div>

    </div>
  )}
}

export default Haikyuu;
